import { Injectable, OnDestroy } from '@angular/core';
import { NotificationService } from '@progress/kendo-angular-notification';
import { TranslateService } from 'src/common/translate/services/translate.service';
import { SelfSchedulingDataService } from './self.scheduling.data.service';
import { MESSAGE_SUFFIX } from 'src/common/translate/translate.suffix';
import { takeUntilDestroy } from 'take-until-destroy';
import { first } from 'rxjs/operators';
import { LogManager } from 'src/common/log/log.manager';
import { LogCat } from 'src/common/log/log.categories';

/**
 ****************************************************************
 * Service class for common functionalities.
 *
 * Created by Shai Zelman on 31/08/2025.
 ****************************************************************
 */

@Injectable({providedIn: "root"})
export class SelfSchedulingCommonService implements OnDestroy {
	constructor(private translateService: TranslateService, private notificationService: NotificationService, private selfSchedulingDataService: SelfSchedulingDataService) {

	}

	public showErrorNotification(message: string, style: "error" | "warning" = "error") {
		this.translateService.transform(message + MESSAGE_SUFFIX).pipe(takeUntilDestroy(this), first()).subscribe((translation: string) => {
			this.notificationService.show({
				content: translation,
				hideAfter: 5000,
				animation: { type: "fade", duration: 500 },
				position: { horizontal: 'center', vertical: 'bottom' },
				type: { style: style, icon: true },
				appendTo: this.selfSchedulingDataService.notificationContainerRef,
				width: this.selfSchedulingDataService.notificationContainerRef.element.nativeElement.offsetWidth - 20,
			});
		}, (error) => {
			LogManager.debug(LogCat.SelfScheduling.General, "Unknown error", error);
			this.notificationService.show({
				content: "Error",
				hideAfter: 5000,
				animation: { type: "fade", duration: 500 },
				position: { horizontal: 'center', vertical: 'bottom' },
				type: { style: "error", icon: true },
				appendTo: this.selfSchedulingDataService.notificationContainerRef,
				width: this.selfSchedulingDataService.notificationContainerRef.element.nativeElement.offsetWidth - 20,
			});
		});
	}

	public ngOnDestroy(): void {
		
	}
}
